import { useEffect, useState } from 'react';
import { sendRequest } from '../utils/dateHelpers';
import { RETENTION_SCREEN_STATES } from '../constants/retentionScreenState';

const useRetentionScreenState = () => {
  const [loading, setLoading] = useState(true);
  const [screenState, setScreenState] = useState(RETENTION_SCREEN_STATES.READY);
  const [screenStateMeta, setScreenStateMeta] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchScreenState = async () => {
      try {
        const response = await sendRequest('/retention/screen-state', 'GET');

        if (!isMounted) {
          return;
        }

        setScreenState(response?.screen_state || RETENTION_SCREEN_STATES.READY);
        setScreenStateMeta(response?.screen_state_meta || null);
      } catch (error) {
        if (!isMounted) {
          return;
        }

        setScreenState(RETENTION_SCREEN_STATES.READY);
        setScreenStateMeta(null);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchScreenState();

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    loading,
    screenState,
    screenStateMeta
  };
};

export default useRetentionScreenState;
